import { ElementType, useEffect, useId } from 'react';
import {
  Description,
  DialogPanel,
  DialogTitle,
  Dialog as HeadlessUIDialog,
  DialogProps as HeadlessUIDialogProps,
} from '@headlessui/react';

import { useDialogStore } from 'stores/dialog/dialog';
import { WithRef } from 'support/types/withRef';

const ProcurosDialog = ({
  ref,
  ...props
}: WithRef<Omit<HeadlessUIDialogProps<ElementType>, 'static' | 'unmount' | 'open'>, any>) => {
  const { addDialog, removeDialog, dialogs } = useDialogStore();
  const id = useId();

  useEffect(() => {
    addDialog(id);
    return () => {
      removeDialog(id);
    };
  }, [addDialog, removeDialog, id]);

  const onClose = (value: boolean) => {
    if (dialogs.at(-1) === id) {
      removeDialog(id);
      props.onClose(value);
    }
  };
  return <HeadlessUIDialog {...props} ref={ref} onClose={onClose} />;
};

export const Dialog = Object.assign(ProcurosDialog, {
  Panel: DialogPanel,
  Title: DialogTitle,
  Description: Description,
});
